<template>
<div tabindex="0" class="e-card" id="price">
  <div class="e-card-title" style="display: inline-block">New Miscellaneous Price</div>
    <div>
      <div class="e-card-content">
        <div class="form-row"  v-if="!canChangeProductType">
          <div style="width:80%;" class="form-row-input">
          Product Type: {{productDescription}}
          </div>
        </div>

        <div class="form-row" v-if="canChangeProductType">
          <div style="width:80%;" class="form-row-input">
            <ejs-dropdownlist
            float-label-type="Always"
            :dataSource='productTypes'
            :fields='productTypeFields'
            placeholder='Select a product'
            v-model='productId'
            sortOrder="Ascending">
            </ejs-dropdownlist>
          </div>
        </div>

        <div class="form-row">
          <div style="width:40%;" class="form-row-input">
            <ejs-dropdownlist
              float-label-type="Always"
              :dataSource='chargeByOptions'
              :fields='chargeByFields'
              placeholder='Charge By'
              v-model='chargeBy' >
            </ejs-dropdownlist>
          </div>
        </div>

         <div class="form-row">
          <div style="width:10%;" class="form-row-input">
            <scc-input-validator
            :rules="[positiveNumberRule]"
            :number="this.amountApp"
            >
              <ejs-numerictextbox
              float-label-type="Always"
              placeholder="Amount *"
              :showSpinButton='spin'
              v-model="amountApp" />
            </scc-input-validator>
          </div>
        </div>
       <!-- <div class="form-row">
          <div  class="form-row-input">Levy Fee Type</div>
        </div>
        <div class="form-row">
          <div style="width:80%;" class="form-row-input">
            <ejs-radiobutton label='% Percentage' name='levyTypeSelect'
            :checked="levyFeeType === '%'"
            :htmlAttributes="{ value: '%' }"  v-model='levyFeeType'/>
            &nbsp;&nbsp;
            <ejs-radiobutton label='$ Amount' name='levyTypeSelect'
            :checked="levyFeeType === '$'"
            :htmlAttributes="{ value: '$' }"  v-model='levyFeeType'/>
          </div>
        </div> -->
       <!-- <div class="form-row">
          <div style="width:10%;" class="form-row-input">
            <scc-input-validator
              :rules="[positiveNumberRule]"
              :number="this.amountTank"
            >
              <ejs-numerictextbox
              float-label-type="Always"
              placeholder="Per Tank*"
              format="C2"
              :showSpinButton='spin'
              v-model="amountTank" />
            </scc-input-validator>
          </div>
        </div> -->

        <div class="form-row" v-show="this.chargeBy == 'Application'">
          <div style="width:10%;" class="form-row-input">
            <div style="flex:3;">
              <scc-input-validator
                :rules="[positiveNumberRule]"
                :number="this.amountLevy"
              >
                <ejs-numerictextbox
                float-label-type="Always"
                placeholder="Levy*"
                format = 'C2'
                :showSpinButton='spin'
                v-model="amountLevy" />
              </scc-input-validator>
            </div>
          </div>
        </div>
        <!-- <div class="form-row">
          <div style="width:10%;" class="form-row-input">
            <scc-input-validator
              :rules="[positiveNumberRule]"
              :number="this.amountPerAddress"
            >
              <ejs-numerictextbox
              float-label-type="Always"
              placeholder="Per Address*"
              format="C2"
              :showSpinButton="spin"
              v-model="amountPerAddress" />
            </scc-input-validator>
          </div>
        </div> -->
        <div class="form-row">
          <div style="width:18%;" class="form-row-input">
            <ejs-datepicker
            v-model="effectiveStartDate"
            :placeholder="dateMarker"
            :min="minVal"
            :max="maxVal"
            float-label-type="Always"
            :format="dateFormat"></ejs-datepicker>
          </div>
        </div>

        <div class="align-center-bottom">
        <ejs-button type="button" v-on:click.native="onSubmitButtonClick"
                      cssClass="e-info margin-button">Submit</ejs-button>
        <ejs-button v-on:click.native="onCancelButtonClick"
                      cssClass="e-danger margin-button">Cancel</ejs-button>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import { TextBoxPlugin, NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import { RadioButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import SccInputValidator from '@/components/base/scc-input-validator.vue';

import { POST_PRODUCT_PRICE, FETCH_PRODUCT_PRICE } from '../store';

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(RadioButtonPlugin);

export default {
  name: 'AddMiscellaneousPrice',
  components: {
    SccInputValidator,
  },
  data() {
    return {
      priceId: null,
      title: 'New Price',
      productId: null,
      productType: '',
      amountApp: 0,
      amountTank: 0,
      amountLevy: 0,
      amountPerAddress: 0,
      chargeBy: '',
      effectiveStartDate: null,
      allowChangeProductType: true,
      productDescription: '',
      dateMarker: 'Select Start Date(yyyy-mm-yy)',
      dateFormat: 'yyyy-MM-dd',
      productTypes: [],
      productTypeFields: { text: 'productDescription', value: 'productId' },

      chargeByOptions: [],
      chargeByFields: { text: 'chargeBy', value: 'chargeBy' },

      levyFeeType: null,
      levyFeeTypes: [{ label: 'percentage', value: '%' }, { label: 'amount', value: '$' }],
      positiveNumberRule: {
        regEx: '^(\\+)?\\d+(\\.\\d*)?$',
        message: 'Please provide a positive amount.',
      },
      spin: false,
    };
  },

  created() {
    this.productTypes = this.$store.getters.productTypes.filter((x) => x.productType === 'MisFix' || x.productType === 'MisPermit' || x.productType === 'MisPH' || x.productType === 'MisPKM');
    // To Add Filter to the options
    this.chargeByOptions = this.$store.getters.chargeByOptions.filter((x) => x.productType === 'MisFix' || x.productType === 'MisPermit' || x.productType === 'MisPH' || x.productType === 'MisPKM');

    if (this.$route.params.id !== '0') {
      this.priceId = this.$route.params.id;
      this.allowChangeProductType = false;
      this.FetchProductPrice();
    } else {
      this.priceId = '';
    }
  },

  computed: {
    canChangeProductType() {
      return this.allowChangeProductType;
    },
    minVal() {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth();
      const currentDay = today.getDate() + 1;
      return new Date(currentYear, currentMonth, currentDay);
    },
    maxVal() {
      const today = new Date();
      const currentYear = today.getFullYear() + 2;
      const currentMonth = today.getMonth();
      const currentDay = today.getDate();
      return new Date(currentYear, currentMonth, currentDay);
    },
  },

  methods: {

    getProductDescription() {
      const product = this.productTypes.find((x) => x.productId === this.productId);
      return product.productDescription;
    },
    onCancelButtonClick() {
      this.$router.push('/products/productprices/');
    },
    async onSubmitButtonClick() {
      if (this.productId === null || this.productId === '') {
        this.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Please select a product type first!',
          cssClass: 'e-toast-info',
          timeOut: 5000,
        });
        this.$parent.$parent.$refs.notifierRef.show();
        return;
      }
      let formDataFail = false;
      let errorMessage = '';

      if (this.effectiveStartDate === null) {
        formDataFail = true;
        errorMessage += 'Please select start date!<br>';
      }
      this.isAmountLevyValid = true;
      if (formDataFail) {
        this.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content: errorMessage,
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
        this.$parent.$parent.$refs.notifierRef.show();
        return;
      }

      try {
        const data = {};
        if (this.priceId !== null && this.priceId !== '') {
          data.priceId = this.priceId;
        }
        if (this.chargeBy === 'Percentage') {
          data.levyFeeType = '%';
        }
        if (this.chargeBy !== 'Percentage') {
          data.levyFeeType = '$';
        }
        data.productId = this.productId;
        data.amountApp = this.amountApp;
        // data.amountTank = this.amountTank;
        data.amountLevy = this.amountLevy;
        // data.amountPerAddress = this.amountPerAddress;
        data.chargeBy = this.chargeBy;
        data.effectiveStartDate = this.effectiveStartDate;

        await this.$store.dispatch(POST_PRODUCT_PRICE, { data });
        this.$parent.$parent.notificationToasts.push({
          title: 'Success!',
          content: 'Miscellaneous price saved.',
          cssClass: 'e-toast-success',
          timeOut: 5000,
        });
        this.$router.push('/products/productprices/');
      } catch (error) {
        console.error(error);
      }

      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },

    async FetchProductPrice() {
      if (this.priceId != null && this.priceId !== '' && this.priceId !== '0') {
        const { priceId } = this;
        this.title = 'Update Product Price';
        await this.$store.dispatch(FETCH_PRODUCT_PRICE, { priceId });

        const {
          productId, amountApp, amountTank, amountLevy, amountPerAddress,
          levyFeeType, chargeBy, effectiveStartDate, effectiveEndDate,
        } = this.$store.getters.currentPrice;
        // this.priceId = priceId;
        this.productId = productId;
        this.amountApp = amountApp;
        this.amountTank = amountTank;
        this.amountLevy = amountLevy;
        this.amountPerAddress = amountPerAddress;
        this.levyFeeType = levyFeeType;
        this.chargeBy = chargeBy;
        this.effectiveStartDate = effectiveStartDate;
        this.effectiveEndDate = effectiveEndDate;
        this.productDescription = this.getProductDescription();
      } else {
        // little difference from product prospect
        this.title = 'New Miscellaneous Product Price';
      }
    },
  },
};
</script>

<style>
 @import '../../../assets/styles/eservices-base.css';
 .e-card-content {
  margin: 0% !important;
}
</style>
